import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import './ApplicationOptionModal.scss'
import Modal from '../../../components/modal'
import useI18n from '../../../i18n/useI18n'

const ApplicationOptionModal = ({ isOpen, onClose, onSelectOption, universityWebsite, universityName }) => {
  const { t } = useI18n()
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const handleGoToWebsite = () => {
    if (universityWebsite) {
      window.open(universityWebsite, '_blank')
    }
    onClose()
  }

  const handleApplyViaAgency = () => {
    onSelectOption('agency')
    onClose()
  }

  if (!isOpen) return null

  if (typeof document === 'undefined' || !document.body) {
    return null
  }

  const modalContent = (
<Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('UNIVERSITIES_APPLICATION_OPTIONS_TITLE')}
    //   subtitle={}
      icon="zmdi-info-outline"
      size="large"
    >
          <p className="modal-description">
            <strong>{universityName}</strong>
          {t('UNIVERSITIES_APPLICATION_OPTIONS_DESCRIPTION', { universityName: universityName })}
          </p>

          <div className="option-cards">
            <div className="option-card" onClick={handleGoToWebsite}>
              <div className="option-icon">
                <i className="zmdi zmdi-globe"></i>
              </div>
              <h4>{t('UNIVERSITIES_APPLICATION_OPTION_WEBSITE_TITLE')}</h4>
              <p>{t('UNIVERSITIES_APPLICATION_OPTION_WEBSITE_DESCRIPTION')}</p>
              <button className="btn btn-outline-primary">
                {t('UNIVERSITIES_APPLICATION_OPTION_WEBSITE_BUTTON')}
                <i className="zmdi zmdi-arrow-right ml-2"></i>
              </button>
            </div>

            <div className="divider">
              <span>{t('UNIVERSITIES_APPLICATION_OPTION_OR')}</span>
            </div>

            <div className="option-card" onClick={handleApplyViaAgency}>
              <div className="option-icon">
                <i className="zmdi zmdi-file-text"></i>
              </div>
              <h4>{t('UNIVERSITIES_APPLICATION_OPTION_AGENCY_TITLE')}</h4>
              <p>{t('UNIVERSITIES_APPLICATION_OPTION_AGENCY_DESCRIPTION')}</p>
              <button className="btn btn-primary">
                {t('UNIVERSITIES_APPLICATION_OPTION_AGENCY_BUTTON')}
                <i className="zmdi zmdi-arrow-right ml-2"></i>
              </button>
            </div>
          </div>
        
      </Modal>
  )

  return createPortal(modalContent, document.body)
}

export default ApplicationOptionModal

